function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useMemo } from 'react';
import { HeaderRenderer } from './HeaderRenderer';

/**
 * Hook to enhance columns with filtering headers and row expansion support
 * 
 * @param {Array} columns - Base column definitions
 * @param {boolean} enableFiltering - Whether filtering is enabled
 * @param {Object} filters - Current filter state
 * @param {Function} updateFilter - Callback to update filters
 * @param {boolean} enableRowExpansion - Whether row expansion is enabled
 * @param {Function} toggleRowExpansion - Callback to toggle row expansion
 * @param {Function} isRowExpandable - Function to check if row is expandable
 * @param {string} expandedRowProp - Property name for expansion state
 * @param {boolean} showHeaderFilters - Whether filter controls should render inside headers
 * @returns {Array} Enhanced columns
 */
export function useDataGridColumns(columns, enableFiltering, filters, updateFilter, enableRowExpansion, toggleRowExpansion, isRowExpandable, expandedRowProp) {
  let showHeaderFilters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;
  return useMemo(() => {
    let result = columns;

    // Add filtering support
    if (enableFiltering) {
      result = result.map(column => {
        // If column already has renderHeaderCell, don't override
        if (column.renderHeaderCell) {
          return column;
        }

        // Add HeaderRenderer for filtering
        return {
          ...column,
          renderHeaderCell: props => /*#__PURE__*/React.createElement(HeaderRenderer, _extends({}, props, {
            filters: filters,
            onFilterChange: updateFilter,
            showFilter: showHeaderFilters
          }))
        };
      });
    }

    // Add row expansion support - make toggle function available to all columns
    if (enableRowExpansion) {
      result = result.map(column => ({
        ...column,
        toggleRowExpansion,
        isRowExpandable,
        expandedRowProp
      }));
    }
    return result;
  }, [columns, enableFiltering, filters, updateFilter, enableRowExpansion, toggleRowExpansion, isRowExpandable, expandedRowProp, showHeaderFilters]);
}